import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withCtx as _withCtx, vModelSelect as _vModelSelect, withKeys as _withKeys, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = {
  key: 1,
  class: "card"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "text-md-right" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "inline-items text-md-right align-middle mt-2" }
const _hoisted_14 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_15 = {
  key: 1,
  class: "mr-3"
}
const _hoisted_16 = { class: "table-responsive my-3 font-12 tableFixHead" }
const _hoisted_17 = { class: "table table-bordered table-shadowed mb-0 fixed-ht-table" }
const _hoisted_18 = { class: "table-primary nowrap-text" }
const _hoisted_19 = { scope: "col" }
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = { class: "form-check pl-0" }
const _hoisted_22 = {
  class: "form-check-label ml-3",
  for: "defaultCheck1"
}
const _hoisted_23 = { scope: "col" }
const _hoisted_24 = { class: "form-check pl-0" }
const _hoisted_25 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_26 = { scope: "col" }
const _hoisted_27 = { class: "form-check pl-0" }
const _hoisted_28 = {
  class: "form-check-label ml-3",
  for: "defaultCheck3"
}
const _hoisted_29 = { scope: "col" }
const _hoisted_30 = { class: "form-check pl-0" }
const _hoisted_31 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_32 = { scope: "col" }
const _hoisted_33 = { class: "form-check pl-0" }
const _hoisted_34 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_35 = { scope: "col" }
const _hoisted_36 = { class: "form-check pl-0" }
const _hoisted_37 = {
  class: "form-check-label ml-3",
  for: "defaultCheck4"
}
const _hoisted_38 = { scope: "col" }
const _hoisted_39 = { class: "form-check pl-0" }
const _hoisted_40 = {
  class: "form-check-label ml-3",
  for: "defaultCheck4"
}
const _hoisted_41 = { scope: "col" }
const _hoisted_42 = { class: "form-check pl-0" }
const _hoisted_43 = {
  class: "form-check-label ml-3",
  for: "defaultCheck5"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "desc-wrap" }
const _hoisted_47 = { class: "text-nowrap" }
const _hoisted_48 = { class: "text-nowrap" }
const _hoisted_49 = { class: "text-nowrap" }
const _hoisted_50 = { class: "text-nowrap" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "text-nowrap" }
const _hoisted_54 = { class: "text-nowrap" }
const _hoisted_55 = /*#__PURE__*/_createVNode("td", { colspan: 7 }, null, -1)
const _hoisted_56 = { class: "text-nowrap" }
const _hoisted_57 = { class: "text-nowrap" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-12" }
const _hoisted_60 = { class: "text-md-right" }
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_62 = {
  key: 0,
  class: "my-3"
}
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 2,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_66 = {
  key: 0,
  class: "company-logo-wrap border p-1 rounded my-3 bg-white"
}
const _hoisted_67 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_68 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_69 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_70 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_71 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_72 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_73 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_74 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_75 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_76 = { class: "inline-items mt-3" }
const _hoisted_77 = {
  key: 0,
  class: "form-group"
}
const _hoisted_78 = { class: "signature-wrap" }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = { class: "inline-items" }
const _hoisted_81 = { class: "upload-btn-wrapper" }
const _hoisted_82 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_83 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { class: "upload-btn-wrapper" }
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_88 = { class: "form-wrap mt-2" }
const _hoisted_89 = { class: "form-group mb-2" }
const _hoisted_90 = { class: "d-flex align-items-center mb-2" }
const _hoisted_91 = {
  for: "",
  class: "mr-2 mb-0"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("h3", { class: "title" }, [
  /*#__PURE__*/_createVNode("strong", null, "Choose Members")
], -1)
const _hoisted_93 = { class: "bg-light rounded border my-2" }
const _hoisted_94 = { class: "bordered-tab-wrap" }
const _hoisted_95 = {
  class: "nav nav-tabs",
  id: "myTab3",
  role: "tablist"
}
const _hoisted_96 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_97 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_98 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_99 = { class: "tab-content" }
const _hoisted_100 = { class: "form-group inline-items my-2 align-middle" }
const _hoisted_101 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_102 = /*#__PURE__*/_createVNode("option", { value: "channel" }, "From Channel", -1)
const _hoisted_103 = /*#__PURE__*/_createVNode("option", { value: "member" }, "From Member", -1)
const _hoisted_104 = { class: "row" }
const _hoisted_105 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_106 = { class: "rounded border mb-2" }
const _hoisted_107 = { class: "px-3" }
const _hoisted_108 = { class: "row align-items-center" }
const _hoisted_109 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Channels")
  ])
], -1)
const _hoisted_110 = { class: "col-md-8" }
const _hoisted_111 = { class: "search-wrap  my-1" }
const _hoisted_112 = { class: "search-ico" }
const _hoisted_113 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_114 = { key: 0 }
const _hoisted_115 = /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "No channels found.", -1)
const _hoisted_116 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_117 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_118 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading channels...", -1)
const _hoisted_119 = { class: "col-md-9" }
const _hoisted_120 = { class: "rounded border mb-2" }
const _hoisted_121 = { class: "px-3" }
const _hoisted_122 = { class: "row align-items-center" }
const _hoisted_123 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Members")
  ])
], -1)
const _hoisted_124 = { class: "col-md-8" }
const _hoisted_125 = { class: "search-wrap  my-1" }
const _hoisted_126 = { class: "search-ico" }
const _hoisted_127 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_128 = { key: 0 }
const _hoisted_129 = {
  key: 1,
  class: "text-muted text-center"
}
const _hoisted_130 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_131 = { class: "form-group inline-items my-2 align-middle" }
const _hoisted_132 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_133 = /*#__PURE__*/_createVNode("option", { value: "channel" }, "From Channel", -1)
const _hoisted_134 = /*#__PURE__*/_createVNode("option", { value: "member" }, "From Member", -1)
const _hoisted_135 = { class: "row" }
const _hoisted_136 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_137 = { class: "rounded border mb-2" }
const _hoisted_138 = { class: "px-3" }
const _hoisted_139 = { class: "row align-items-center" }
const _hoisted_140 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Projects")
  ])
], -1)
const _hoisted_141 = { class: "col-md-8" }
const _hoisted_142 = { class: "search-wrap  my-1" }
const _hoisted_143 = { class: "search-ico" }
const _hoisted_144 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_145 = { key: 0 }
const _hoisted_146 = /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "No Projects found.", -1)
const _hoisted_147 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_148 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_149 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading projects...", -1)
const _hoisted_150 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_151 = { class: "rounded border mb-2" }
const _hoisted_152 = { class: "px-3" }
const _hoisted_153 = { class: "row align-items-center" }
const _hoisted_154 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Channels")
  ])
], -1)
const _hoisted_155 = { class: "col-md-8" }
const _hoisted_156 = { class: "search-wrap  my-1" }
const _hoisted_157 = { class: "search-ico" }
const _hoisted_158 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_159 = { key: 0 }
const _hoisted_160 = /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "No channels found.", -1)
const _hoisted_161 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_162 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_163 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading channels...", -1)
const _hoisted_164 = { class: "col-md-6" }
const _hoisted_165 = { class: "rounded border mb-2" }
const _hoisted_166 = { class: "px-3" }
const _hoisted_167 = { class: "row align-items-center" }
const _hoisted_168 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Members")
  ])
], -1)
const _hoisted_169 = { class: "col-md-8" }
const _hoisted_170 = { class: "search-wrap  my-1" }
const _hoisted_171 = { class: "search-ico" }
const _hoisted_172 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_173 = { key: 0 }
const _hoisted_174 = {
  key: 1,
  class: "text-muted text-center"
}
const _hoisted_175 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_176 = { class: "row" }
const _hoisted_177 = { class: "col-md-6" }
const _hoisted_178 = { class: "rounded border my-2 p-3" }
const _hoisted_179 = { class: "form-group row mb-1" }
const _hoisted_180 = /*#__PURE__*/_createVNode("label", {
  for: "firstName",
  class: "col-sm-2 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_181 = { class: "col-sm-10" }
const _hoisted_182 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_183 = { class: "form-group row mb-1" }
const _hoisted_184 = /*#__PURE__*/_createVNode("label", {
  for: "lastName",
  class: "col-sm-2 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_185 = { class: "col-sm-10" }
const _hoisted_186 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_187 = { class: "form-group row mb-1" }
const _hoisted_188 = /*#__PURE__*/_createVNode("label", {
  for: "contact",
  class: "col-sm-2 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Email/Phone "),
  /*#__PURE__*/_createVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_189 = { class: "col-sm-10" }
const _hoisted_190 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_191 = /*#__PURE__*/_createVNode("div", { class: "form-group mb-0 text-right" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn default-btn"
  }, "Add")
], -1)
const _hoisted_192 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_193 = { class: "rounded border my-2 p-3" }
const _hoisted_194 = { class: "flex-grow-1" }
const _hoisted_195 = { class: "mb-0" }
const _hoisted_196 = {
  key: 3,
  class: "bg-light p-2 rounded border mb-3 custom-scroll user-cards-list"
}
const _hoisted_197 = /*#__PURE__*/_createVNode("div", { class: "form-group mt-3" }, [
  /*#__PURE__*/_createVNode("label", { for: "" }, "Selected Members")
], -1)
const _hoisted_198 = { class: "row mx-n2" }
const _hoisted_199 = { class: "shadowed-card bg-white h-100 p-2 user-card" }
const _hoisted_200 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user" }, null, -1)
const _hoisted_201 = { key: 0 }
const _hoisted_202 = { key: 1 }
const _hoisted_203 = { key: 2 }
const _hoisted_204 = { key: 3 }
const _hoisted_205 = { class: "row mx-n2" }
const _hoisted_206 = {
  key: 0,
  class: "col-xl-6 px-2"
}
const _hoisted_207 = /*#__PURE__*/_createVNode("i", { class: "fa fa-envelope" }, null, -1)
const _hoisted_208 = {
  key: 1,
  class: "col-xl-6 px-2"
}
const _hoisted_209 = /*#__PURE__*/_createVNode("i", { class: "fa fa-phone" }, null, -1)
const _hoisted_210 = { class: "d-flex align-items-center justify-content-around border-top mt-1 pt-1" }
const _hoisted_211 = { class: "flex-shrink-0 mr-2" }
const _hoisted_212 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Notify By")
], -1)
const _hoisted_213 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_214 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bell" }, null, -1)
const _hoisted_215 = /*#__PURE__*/_createTextVNode(" Mail")
const _hoisted_216 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_217 = /*#__PURE__*/_createVNode("i", { class: "fa fa-sms" }, null, -1)
const _hoisted_218 = /*#__PURE__*/_createTextVNode(" SMS")
const _hoisted_219 = { class: "flex-grow-1 text-right" }
const _hoisted_220 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_221 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_222 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_223 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_224 = { class: "row" }
const _hoisted_225 = { class: "col-md-6" }
const _hoisted_226 = { class: "form-wrap mt-2" }
const _hoisted_227 = { class: "form-group" }
const _hoisted_228 = /*#__PURE__*/_createVNode("i", { class: "far fa-comment ml-2" }, null, -1)
const _hoisted_229 = {
  key: 0,
  class: "ml-2 font-weight-bold"
}
const _hoisted_230 = { class: "row" }
const _hoisted_231 = { class: "col-md-6" }
const _hoisted_232 = { class: "form-check pl-0" }
const _hoisted_233 = {
  class: "form-check-label ml-3",
  for: "defaultCheck6"
}
const _hoisted_234 = { class: "col-md-6 text-md-end" }
const _hoisted_235 = {
  href: "#",
  class: "btn default-btn btn-outline",
  "data-toggle": "modal",
  "data-target": "#previewModal"
}
const _hoisted_236 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_237 = {
  key: 4,
  class: "row"
}
const _hoisted_238 = { class: "col-md-12 error-list mt-3" }
const _hoisted_239 = { class: "form-group" }
const _hoisted_240 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_241 = { class: "modal-wrap default-modal" }
const _hoisted_242 = {
  key: 0,
  class: "custom-modal-overlay"
}
const _hoisted_243 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_244 = { class: "modal-content" }
const _hoisted_245 = { class: "modal-header" }
const _hoisted_246 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "editCustomerModalLabel"
}, null, -1)
const _hoisted_247 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_248 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_249 = { class: "row mx-n2" }
const _hoisted_250 = { class: "col-xl-6 px-2" }
const _hoisted_251 = { class: "form-group" }
const _hoisted_252 = { class: "text-red" }
const _hoisted_253 = { class: "col-xl-6 px-2" }
const _hoisted_254 = { class: "form-group" }
const _hoisted_255 = { class: "text-red" }
const _hoisted_256 = { class: "col-xl-6 px-2" }
const _hoisted_257 = { class: "form-group" }
const _hoisted_258 = { class: "text-red" }
const _hoisted_259 = { class: "col-xl-6 px-2" }
const _hoisted_260 = { class: "form-group" }
const _hoisted_261 = { for: "" }
const _hoisted_262 = { class: "text-red" }
const _hoisted_263 = { class: "col-xl-6 px-2" }
const _hoisted_264 = { class: "form-group" }
const _hoisted_265 = { class: "notify-by-form-group" }
const _hoisted_266 = { class: "form-check form-check-inline" }
const _hoisted_267 = { class: "form-check-label" }
const _hoisted_268 = { class: "form-check form-check-inline" }
const _hoisted_269 = { class: "form-check-label" }
const _hoisted_270 = { class: "text-red" }
const _hoisted_271 = { class: "modal-footer" }
const _hoisted_272 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_273 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "previewModal",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_274 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_275 = { class: "modal-content" }
const _hoisted_276 = { class: "modal-header justify-content-end" }
const _hoisted_277 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_278 = { class: "modal-body bg-light" }
const _hoisted_279 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_280 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_281 = { class: "flex-grow-1" }
const _hoisted_282 = { class: "invoice-logo" }
const _hoisted_283 = { class: "invoice-address" }
const _hoisted_284 = { class: "uppercase-text" }
const _hoisted_285 = { class: "flex-shrink-0 mt-sm-0 mt-3" }
const _hoisted_286 = { class: "text-muted" }
const _hoisted_287 = { class: "text-muted" }
const _hoisted_288 = { key: 1 }
const _hoisted_289 = {
  key: 2,
  class: "row"
}
const _hoisted_290 = { class: "col-md-3" }
const _hoisted_291 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_292 = { class: "col-md-3" }
const _hoisted_293 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_294 = { class: "col-md-3" }
const _hoisted_295 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_296 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_297 = { key: 0 }
const _hoisted_298 = { class: "row" }
const _hoisted_299 = { class: "mt-3 border p-2" }
const _hoisted_300 = { key: 0 }
const _hoisted_301 = { key: 1 }
const _hoisted_302 = { key: 2 }
const _hoisted_303 = { class: "table-responsive mt-4 font-12" }
const _hoisted_304 = { class: "table mb-0 table-borderless" }
const _hoisted_305 = { class: "nowrap-text" }
const _hoisted_306 = { class: "table-active" }
const _hoisted_307 = { scope: "col" }
const _hoisted_308 = {
  key: 0,
  scope: "col"
}
const _hoisted_309 = {
  key: 1,
  scope: "col"
}
const _hoisted_310 = {
  key: 2,
  scope: "col"
}
const _hoisted_311 = {
  key: 3,
  scope: "col"
}
const _hoisted_312 = {
  key: 4,
  scope: "col"
}
const _hoisted_313 = {
  key: 5,
  scope: "col"
}
const _hoisted_314 = {
  key: 6,
  scope: "col"
}
const _hoisted_315 = {
  key: 7,
  scope: "col",
  class: "text-end"
}
const _hoisted_316 = { key: 0 }
const _hoisted_317 = { key: 1 }
const _hoisted_318 = { key: 0 }
const _hoisted_319 = { class: "desc-wrap" }
const _hoisted_320 = { key: 1 }
const _hoisted_321 = { key: 2 }
const _hoisted_322 = { key: 3 }
const _hoisted_323 = { key: 4 }
const _hoisted_324 = { key: 5 }
const _hoisted_325 = { key: 0 }
const _hoisted_326 = { key: 1 }
const _hoisted_327 = { key: 6 }
const _hoisted_328 = { key: 7 }
const _hoisted_329 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_330 = { class: "row justify-content-end" }
const _hoisted_331 = { class: "col-lg-4 col-md-6" }
const _hoisted_332 = { class: "total-box mb-4" }
const _hoisted_333 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_334 = { class: "border-top border-top-dashed fs-15" }
const _hoisted_335 = { scope: "row" }
const _hoisted_336 = { class: "text-end" }
const _hoisted_337 = { key: 4 }
const _hoisted_338 = {
  key: 5,
  class: "mt-4"
}
const _hoisted_339 = {
  key: 6,
  class: "tab-wrap bg-white rounded px-3 pb-3 border mt-3"
}
const _hoisted_340 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_341 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_342 = {
  class: "nav-link active",
  id: "Acknowledgement-tab",
  "data-toggle": "tab",
  "data-target": "#Acknowledgement",
  type: "button",
  role: "tab",
  "aria-controls": "Acknowledgement",
  "aria-selected": "true"
}
const _hoisted_343 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_344 = {
  class: "nav-link",
  id: "LegalStatement-tab",
  "data-toggle": "tab",
  "data-target": "#LegalStatement",
  type: "button",
  role: "tab",
  "aria-controls": "LegalStatement",
  "aria-selected": "false"
}
const _hoisted_345 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_346 = {
  class: "tab-pane fade show active",
  id: "Acknowledgement",
  role: "tabpanel",
  "aria-labelledby": "Acknowledgement-tab"
}
const _hoisted_347 = {
  class: "tab-pane fade",
  id: "LegalStatement",
  role: "tabpanel",
  "aria-labelledby": "LegalStatement-tab"
}
const _hoisted_348 = {
  key: 7,
  class: "alert alert-info mt-3"
}
const _hoisted_349 = { class: "mb-0" }
const _hoisted_350 = {
  key: 8,
  class: "mt-3 pl-3"
}
const _hoisted_351 = { class: "mb-0" }
const _hoisted_352 = /*#__PURE__*/_createVNode("strong", null, " Channel: ", -1)
const _hoisted_353 = {
  key: 9,
  class: "row"
}
const _hoisted_354 = { class: "col-md-4 mt-4" }
const _hoisted_355 = { class: "signature-wrap mt-2" }
const _hoisted_356 = { class: "modal-footer" }
const _hoisted_357 = { class: "modal-wrap default-modal" }
const _hoisted_358 = {
  class: "modal fade",
  id: "addCompanyInfo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_359 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_360 = { class: "modal-content" }
const _hoisted_361 = { class: "modal-header" }
const _hoisted_362 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_363 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_364 = { class: "modal-body" }
const _hoisted_365 = { class: "row" }
const _hoisted_366 = { class: "col-md-12" }
const _hoisted_367 = {
  key: 0,
  class: "form-group"
}
const _hoisted_368 = { for: "" }
const _hoisted_369 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_370 = { class: "form-group" }
const _hoisted_371 = { for: "" }
const _hoisted_372 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_373 = { class: "form-group" }
const _hoisted_374 = {
  for: "",
  class: "to-upper"
}
const _hoisted_375 = { class: "text-danger" }
const _hoisted_376 = { class: "form-group" }
const _hoisted_377 = { for: "" }
const _hoisted_378 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_379 = { class: "custom-file" }
const _hoisted_380 = { class: "upload-btn-wrapper" }
const _hoisted_381 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_382 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_383 = { class: "form-group" }
const _hoisted_384 = { for: "" }
const _hoisted_385 = { class: "form-group" }
const _hoisted_386 = { for: "" }
const _hoisted_387 = { class: "modal-footer" }
const _hoisted_388 = { class: "modal-wrap default-modal" }
const _hoisted_389 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_390 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_391 = { class: "modal-content" }
const _hoisted_392 = { class: "modal-header" }
const _hoisted_393 = {
  class: "modal-title",
  id: "deleteModalLabel"
}
const _hoisted_394 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_395 = { class: "modal-body" }
const _hoisted_396 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_397 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_VoiceToText = _resolveComponent("VoiceToText")
  const _component_Label = _resolveComponent("Label")
  const _component_AppEmailAndPhoneNumberValidate = _resolveComponent("AppEmailAndPhoneNumberValidate")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")
  const _component_Editor = _resolveComponent("Editor")
  const _component_ToDoChatChannelModel = _resolveComponent("ToDoChatChannelModel")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.getItemList)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      (!_ctx.state.ui.isLoading.getItemList)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn default-btn outline d-inline-block",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoListJobEstimation && _ctx.gotoListJobEstimation(...args)))
                  }, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.errors.errorList.sendJobEstimation,
          hasError: _ctx.state.ui.errors.hasError
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("h3", _hoisted_11, _toDisplayString(_ctx.state.sendData.title), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1)
                ]),
                (_ctx.state.data.modifiedCreatedDate)
                  ? (_openBlock(), _createBlock("li", _hoisted_14, _toDisplayString(_ctx.state.data.modifiedCreatedDate), 1))
                  : (_openBlock(), _createBlock("li", _hoisted_15, _toDisplayString(_ctx.state.selectedDate), 1)),
                _createVNode("li", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('estimation_no')) + ":", 1)
                ]),
                _createVNode("li", null, _toDisplayString(_ctx.state.sendData.no), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("table", _hoisted_17, [
            _createVNode("thead", _hoisted_18, [
              _createVNode("tr", null, [
                _createVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('item')), 1),
                _createVNode("th", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.fields.description = $event)),
                      id: "defaultCheck1"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.description]
                    ]),
                    _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('description')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.fields.quantity = $event)),
                      id: "defaultCheck2"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.quantity]
                    ]),
                    _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('qty')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.fields.unit = $event)),
                      id: "defaultCheck3"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.unit]
                    ]),
                    _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('unit')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.fields.cost = $event)),
                      id: "defaultCheck2"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.cost]
                    ]),
                    _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('cost')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_32, [
                  _createVNode("div", _hoisted_33, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.fields.subTotal = $event)),
                      id: "defaultCheck2"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.subTotal]
                    ]),
                    _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('sub_total')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.fields.markup = $event)),
                      id: "defaultCheck4"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.markup]
                    ]),
                    _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('markup')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.fields.allowance = $event)),
                      id: "defaultCheck4"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.allowance]
                    ]),
                    _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('allowance')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_41, [
                  _createVNode("div", _hoisted_42, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.fields.total = $event)),
                      id: "defaultCheck5"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.total]
                    ]),
                    _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('total')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (item, itemIndex) => {
                return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                  _createVNode("td", null, [
                    (item.item.parent_id)
                      ? (_openBlock(), _createBlock("p", _hoisted_44, _toDisplayString(item.main_item_name) + ": " + _toDisplayString(item.name), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_45, _toDisplayString(item.name), 1))
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_46, [
                      _createVNode("p", null, _toDisplayString(item.description), 1)
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode("p", null, _toDisplayString(item.quantity), 1)
                  ]),
                  _createVNode("td", _hoisted_47, [
                    _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                  ]),
                  _createVNode("td", _hoisted_48, [
                    _createVNode("p", null, _toDisplayString(item.cost), 1)
                  ]),
                  _createVNode("td", _hoisted_49, [
                    _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                  ]),
                  _createVNode("td", _hoisted_50, [
                    (item.markup_type == 1)
                      ? (_openBlock(), _createBlock("p", _hoisted_51, _toDisplayString(item.markup) + " %", 1))
                      : (_openBlock(), _createBlock("p", _hoisted_52, _toDisplayString(item.markup), 1))
                  ]),
                  _createVNode("td", _hoisted_53, [
                    _createVNode("p", null, _toDisplayString(item.allowance), 1)
                  ]),
                  _createVNode("td", _hoisted_54, [
                    _createVNode("p", null, _toDisplayString(item.total), 1)
                  ])
                ]))
              }), 128)),
              _createVNode("tr", null, [
                _hoisted_55,
                _createVNode("td", _hoisted_56, _toDisplayString(_ctx.$t('total')), 1),
                _createVNode("td", _hoisted_57, [
                  _createVNode("p", null, _toDisplayString(_ctx.totalCost), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_58, [
          _createVNode("div", _hoisted_59, [
            _createVNode("div", _hoisted_60, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn btn-outline",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.estimationPreview && _ctx.estimationPreview(...args))),
                "data-target": "#previewModal"
              }, [
                _hoisted_61,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('estimation_preview')), 1)
              ])
            ])
          ])
        ]),
        (!_ctx.state.data.companyInfo.logo)
          ? (_openBlock(), _createBlock("div", _hoisted_62, [
              _createVNode("a", {
                "data-toggle": "modal",
                class: "btn default-btn d-inline-block mr-2",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showCreateCompanyModel && _ctx.showCreateCompanyModel(...args)))
              }, _toDisplayString(_ctx.$t('add_company_information')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.data.companyInfo.acknowledgement &&
                _ctx.state.data.companyInfo.legal_statement
            )
          ? (_openBlock(), _createBlock("p", _hoisted_63, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('company_contract_preview')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.data.companyInfo.acknowledgement &&
                _ctx.state.data.companyInfo.legal_statement
            )
          ? (_openBlock(), _createBlock("div", _hoisted_64, [
              _createVNode("p", null, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')), 1),
                _createVNode("a", {
                  class: "btn default-btn btn-sm ms-2",
                  title: "Edit",
                  href: "javascript:void(0)",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.editCompany && _ctx.editCompany(...args)))
                }, [
                  _hoisted_65,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                ])
              ]),
              (_ctx.state.data.companyInfo.logo)
                ? (_openBlock(), _createBlock("div", _hoisted_66, [
                    (_ctx.state.data.companyInfo.logo && _ctx.state.data.companyInfo.logo.file)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "rounded",
                          src: _ctx.state.data.companyInfo.logo.file
                        ? _ctx.state.data.companyInfo.logo.file
                        : _ctx.state.data.companyInfo.logo
                        ,
                          alt: ""
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          class: "rounded",
                          src: _ctx.state.data.companyInfo.logo,
                          alt: ""
                        }, null, 8, ["src"]))
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_67, [
                _createVNode("ul", _hoisted_68, [
                  _createVNode("li", _hoisted_69, [
                    _createVNode("button", _hoisted_70, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                  ]),
                  _createVNode("li", _hoisted_71, [
                    _createVNode("button", _hoisted_72, _toDisplayString(_ctx.$t('legal_statement')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_73, [
                  _createVNode("div", _hoisted_74, [
                    _createVNode("div", {
                      innerHTML: _ctx.state.data.companyInfo.acknowledgement
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createVNode("div", _hoisted_75, [
                    _createVNode("div", {
                      innerHTML: _ctx.state.data.companyInfo.legal_statement
                    }, null, 8, ["innerHTML"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_76, [
          _createVNode("ul", null, [
            _createVNode("li", null, [
              (_ctx.state.data.cropSignature)
                ? (_openBlock(), _createBlock("div", _hoisted_77, [
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_78, [
                        _createVNode("img", {
                          src: _ctx.state.data.cropSignature,
                          alt: ""
                        }, null, 8, ["src"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_79, [
                _createVNode("div", _hoisted_80, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode("div", _hoisted_81, [
                        _createVNode("button", _hoisted_82, [
                          _hoisted_83,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                        ]),
                        _createVNode("input", {
                          ref: "signatureInput",
                          type: "file",
                          accept: "image/png, image/jpeg",
                          id: "profileUpdate",
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                        }, null, 544)
                      ])
                    ]),
                    _createVNode("li", null, [
                      _createVNode("button", {
                        class: "btn default-btn",
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                      }, [
                        _hoisted_84,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                      ])
                    ]),
                    (_ctx.state.data.haveProfileSign)
                      ? (_openBlock(), _createBlock("li", _hoisted_85, [
                          _createVNode("div", _hoisted_86, [
                            _createVNode("button", {
                              for: "formFileSm",
                              class: "btn default-btn mr-2",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.userSignature('use')))
                            }, [
                              _hoisted_87,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("li", null, [
                      _createVNode("button", {
                        class: "btn red-btn",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearSignature()))
                      }, _toDisplayString(_ctx.$t('clear')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_88, [
          _createVNode("div", _hoisted_89, [
            _createVNode("div", _hoisted_90, [
              _createVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('note')), 1),
              _createVNode(_component_VoiceToText, {
                onStartRecording: _cache[17] || (_cache[17] = ($event: any) => (_ctx.startRecording($event)))
              })
            ]),
            _withDirectives(_createVNode("textarea", {
              class: "form-control h-auto",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.data.note = $event)),
              rows: 10
            }, null, 512), [
              [_vModelText, _ctx.state.data.note]
            ])
          ])
        ]),
        _hoisted_92,
        _createVNode("div", _hoisted_93, [
          _createVNode("div", _hoisted_94, [
            _createVNode("ul", _hoisted_95, [
              _createVNode("li", _hoisted_96, [
                _createVNode("button", {
                  class: ["nav-link", { active: _ctx.state.activeTab === 'projectstb' }],
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.switchTab('projectstb')))
                }, _toDisplayString(_ctx.projectName) + " Members ", 3)
              ]),
              _createVNode("li", _hoisted_97, [
                _createVNode("button", {
                  class: ["nav-link", { active: _ctx.state.activeTab === 'mycustomerstb' }],
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.switchTab('mycustomerstb')))
                }, " All My Customers ", 2)
              ]),
              _createVNode("li", _hoisted_98, [
                _createVNode("button", {
                  class: ["nav-link", { active: _ctx.state.activeTab === 'customerstb' }],
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.switchTab('customerstb')))
                }, " Add Customer ", 2)
              ])
            ]),
            _createVNode("div", _hoisted_99, [
              _withDirectives(_createVNode("div", null, [
                _createVNode("div", _hoisted_100, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode(_component_Label, null, {
                        default: _withCtx(() => [
                          _hoisted_101
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      _withDirectives(_createVNode("select", {
                        name: "",
                        class: "custom-select custom-select-sm",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.data.selectedFilterProjectTab = $event)),
                        onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args)))
                      }, [
                        _hoisted_102,
                        _hoisted_103
                      ], 544), [
                        [_vModelSelect, _ctx.state.data.selectedFilterProjectTab]
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_104, [
                  (!_ctx.state.ui.isHideChannelPart)
                    ? (_openBlock(), _createBlock("div", _hoisted_105, [
                        _createVNode("div", _hoisted_106, [
                          _createVNode("div", _hoisted_107, [
                            _createVNode("div", _hoisted_108, [
                              _hoisted_109,
                              _createVNode("div", _hoisted_110, [
                                _createVNode("div", _hoisted_111, [
                                  _createVNode("div", _hoisted_112, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.customerChannelList(_ctx.state.ui.searchQuery.customerChannel)))
                                    }, [
                                      _hoisted_113
                                    ])
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.debouncedCustomerChannel = $event)),
                                    class: "form-control bg-light",
                                    placeholder: "Press enter to search",
                                    onInput: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onChannelSearchInput && _ctx.onChannelSearchInput(...args))),
                                    onKeyup: _cache[27] || (_cache[27] = _withKeys(($event: any) => (_ctx.customerChannelList(_ctx.state.ui.searchQuery.customerChannel)), ["enter"]))
                                  }, null, 544), [
                                    [_vModelText, _ctx.debouncedCustomerChannel]
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", {
                            class: "vertical-nav-wrap channel-list-box custom-scroll",
                            onScroll: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.handleChannelScroll && _ctx.handleChannelScroll(...args)))
                          }, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.customerChannels, (channel) => {
                                return (_openBlock(), _createBlock("li", {
                                  key: channel.uuid,
                                  class: { active: _ctx.state.data.selectedChannelUuid === channel.uuid }
                                }, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.selectCustomerChannel(channel.uuid))
                                  }, _toDisplayString(channel.name), 9, ["onClick"])
                                ], 2))
                              }), 128)),
                              (_ctx.state.data.customerChannels.length === 0)
                                ? (_openBlock(), _createBlock("li", _hoisted_114, [
                                    _hoisted_115
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.state.ui.isLoading.customerChannelList)
                              ? (_openBlock(), _createBlock("div", _hoisted_116, [
                                  _hoisted_117,
                                  _hoisted_118
                                ]))
                              : _createCommentVNode("", true)
                          ], 32)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_119, [
                    _createVNode("div", _hoisted_120, [
                      _createVNode("div", _hoisted_121, [
                        _createVNode("div", _hoisted_122, [
                          _hoisted_123,
                          _createVNode("div", _hoisted_124, [
                            _createVNode("div", _hoisted_125, [
                              _createVNode("div", _hoisted_126, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.selectCustomerChannel(_ctx.state.data.selectedChannelUuid, _ctx.state.ui.searchQuery.channelMembers)))
                                }, [
                                  _hoisted_127
                                ])
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.debouncedChannelMembers = $event)),
                                class: "form-control bg-light",
                                placeholder: "Press enter to search",
                                onInput: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.onChannelMemberSearchInput && _ctx.onChannelMemberSearchInput(...args))),
                                onKeyup: _cache[32] || (_cache[32] = _withKeys(($event: any) => (_ctx.selectCustomerChannel(_ctx.state.data.selectedChannelUuid, _ctx.state.ui.searchQuery.channelMembers)), ["enter"]))
                              }, null, 544), [
                                [_vModelText, _ctx.debouncedChannelMembers]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", {
                        class: "px-2 border-top pt-3 member-list-box custom-scroll",
                        onScroll: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.handleChannelMemberScroll && _ctx.handleChannelMemberScroll(...args)))
                      }, [
                        _createVNode("div", null, [
                          (_ctx.channelMembers.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_128, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.channelMembers, (member) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "custom-control custom-checkbox",
                                    key: member.user_id
                                  }, [
                                    _createVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: 'member-' + member.user_id,
                                      value: member.user_id,
                                      checked: _ctx.state.data.selectedMemberIds.includes(member.user_id),
                                      onChange: ($event: any) => (_ctx.toggleMemberSelection(member.user_id, $event))
                                    }, null, 40, ["id", "value", "checked", "onChange"]),
                                    _createVNode("label", {
                                      class: "custom-control-label",
                                      for: 'member-' + member.user_id
                                    }, _toDisplayString(member.user_first_name) + " " + _toDisplayString(member.user_last_name) + " (" + _toDisplayString(member.user_email) + ") ", 9, ["for"])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_129, " No members found for this channel. "))
                        ]),
                        (_ctx.state.ui.isLoading.customerChannelMemberList)
                          ? (_openBlock(), _createBlock("div", _hoisted_130, " Loading members... "))
                          : _createCommentVNode("", true)
                      ], 32)
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.state.activeTab === 'projectstb']
              ]),
              _withDirectives(_createVNode("div", null, [
                _createVNode("div", _hoisted_131, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode(_component_Label, null, {
                        default: _withCtx(() => [
                          _hoisted_132
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      _withDirectives(_createVNode("select", {
                        name: "",
                        class: "custom-select custom-select-sm",
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.state.data.selectedFilterCustomerTab = $event)),
                        onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.handleFilterChangeAll && _ctx.handleFilterChangeAll(...args)))
                      }, [
                        _hoisted_133,
                        _hoisted_134
                      ], 544), [
                        [_vModelSelect, _ctx.state.data.selectedFilterCustomerTab]
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_135, [
                  (!_ctx.state.ui.isHideChannelPart)
                    ? (_openBlock(), _createBlock("div", _hoisted_136, [
                        _createVNode("div", _hoisted_137, [
                          _createVNode("div", _hoisted_138, [
                            _createVNode("div", _hoisted_139, [
                              _hoisted_140,
                              _createVNode("div", _hoisted_141, [
                                _createVNode("div", _hoisted_142, [
                                  _createVNode("div", _hoisted_143, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.customerProjectList(_ctx.state.ui.searchQuery.projects)))
                                    }, [
                                      _hoisted_144
                                    ])
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.debouncedProjects = $event)),
                                    class: "form-control bg-light",
                                    placeholder: "Press enter to search",
                                    onInput: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.onProjectSearchInput && _ctx.onProjectSearchInput(...args))),
                                    onKeyup: _cache[39] || (_cache[39] = _withKeys(($event: any) => (_ctx.customerProjectList(_ctx.state.ui.searchQuery.projects)), ["enter"]))
                                  }, null, 544), [
                                    [_vModelText, _ctx.debouncedProjects]
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", {
                            class: "vertical-nav-wrap channel-list-box custom-scroll",
                            onScroll: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.handleProjectScroll && _ctx.handleProjectScroll(...args)))
                          }, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.customerProjects, (project) => {
                                return (_openBlock(), _createBlock("li", {
                                  key: project.uuid,
                                  class: { active: _ctx.state.data.selectedProjectUuid === project.uuid }
                                }, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.projectChannelList(project.uuid))
                                  }, _toDisplayString(project.name), 9, ["onClick"])
                                ], 2))
                              }), 128)),
                              (_ctx.state.data.customerProjects.length === 0)
                                ? (_openBlock(), _createBlock("li", _hoisted_145, [
                                    _hoisted_146
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.state.ui.isLoading.projectList)
                              ? (_openBlock(), _createBlock("div", _hoisted_147, [
                                  _hoisted_148,
                                  _hoisted_149
                                ]))
                              : _createCommentVNode("", true)
                          ], 32)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isHideChannelPart)
                    ? (_openBlock(), _createBlock("div", _hoisted_150, [
                        _createVNode("div", _hoisted_151, [
                          _createVNode("div", _hoisted_152, [
                            _createVNode("div", _hoisted_153, [
                              _hoisted_154,
                              _createVNode("div", _hoisted_155, [
                                _createVNode("div", _hoisted_156, [
                                  _createVNode("div", _hoisted_157, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.projectChannelList(_ctx.state.data.selectedProjectUuid, _ctx.state.ui.searchQuery.customerChannel)))
                                    }, [
                                      _hoisted_158
                                    ])
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.debouncedProjectChannel = $event)),
                                    class: "form-control bg-light",
                                    placeholder: "Press enter to search",
                                    onInput: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.onChannelSearchInput && _ctx.onChannelSearchInput(...args))),
                                    onKeyup: _cache[44] || (_cache[44] = _withKeys(($event: any) => (_ctx.projectChannelList(_ctx.state.data.selectedProjectUuid, _ctx.state.ui.searchQuery.customerChannel)), ["enter"]))
                                  }, null, 544), [
                                    [_vModelText, _ctx.debouncedProjectChannel]
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", {
                            class: "vertical-nav-wrap channel-list-box custom-scroll",
                            onScroll: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.handleProjectChannelScroll && _ctx.handleProjectChannelScroll(...args)))
                          }, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectChannels, (channel) => {
                                return (_openBlock(), _createBlock("li", {
                                  key: channel.uuid,
                                  class: { active: _ctx.state.data.selectedChannelUuid === channel.uuid }
                                }, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.selectCustomerChannel(channel.uuid))
                                  }, _toDisplayString(channel.name), 9, ["onClick"])
                                ], 2))
                              }), 128)),
                              (_ctx.state.data.projectChannels.length === 0)
                                ? (_openBlock(), _createBlock("li", _hoisted_159, [
                                    _hoisted_160
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.state.ui.isLoading.projectChannelList)
                              ? (_openBlock(), _createBlock("div", _hoisted_161, [
                                  _hoisted_162,
                                  _hoisted_163
                                ]))
                              : _createCommentVNode("", true)
                          ], 32)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_164, [
                    _createVNode("div", _hoisted_165, [
                      _createVNode("div", _hoisted_166, [
                        _createVNode("div", _hoisted_167, [
                          _hoisted_168,
                          _createVNode("div", _hoisted_169, [
                            _createVNode("div", _hoisted_170, [
                              _createVNode("div", _hoisted_171, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.debouncedMemberSearch && _ctx.debouncedMemberSearch(...args)))
                                }, [
                                  _hoisted_172
                                ])
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.debouncedMemberSearch = $event)),
                                class: "form-control bg-light",
                                placeholder: "Press enter to search"
                              }, null, 512), [
                                [_vModelText, _ctx.debouncedMemberSearch]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", {
                        class: "px-2 border-top pt-3 member-list-box custom-scroll",
                        onScroll: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.onDynamicMemberScroll && _ctx.onDynamicMemberScroll(...args)))
                      }, [
                        _createVNode("div", null, [
                          (_ctx.channelMembers.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_173, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.channelMembers, (member) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "custom-control custom-checkbox",
                                    key: member.user_id
                                  }, [
                                    _withDirectives(_createVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: 'member-' + member.user_id,
                                      value: member.user_id,
                                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.state.data.selectedMemberIds = $event))
                                    }, null, 8, ["id", "value"]), [
                                      [_vModelCheckbox, _ctx.state.data.selectedMemberIds]
                                    ]),
                                    _createVNode("label", {
                                      class: "custom-control-label",
                                      for: 'member-' + member.user_id
                                    }, _toDisplayString(member.user_first_name) + " " + _toDisplayString(member.user_last_name) + " (" + _toDisplayString(member.user_email || member.user_mobile_number) + ") ", 9, ["for"])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_174, " No members found for this channel. "))
                        ]),
                        (_ctx.state.ui.isLoading.customerChannelMemberList)
                          ? (_openBlock(), _createBlock("div", _hoisted_175, " Loading members... "))
                          : _createCommentVNode("", true)
                      ], 32)
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.state.activeTab === 'mycustomerstb']
              ]),
              _withDirectives(_createVNode("div", null, [
                _createVNode("div", _hoisted_176, [
                  _createVNode("div", _hoisted_177, [
                    _createVNode("div", _hoisted_178, [
                      _createVNode("form", {
                        onSubmit: _cache[53] || (_cache[53] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addCustomer && _ctx.addCustomer(...args)), ["prevent"]))
                      }, [
                        _createVNode("div", _hoisted_179, [
                          _hoisted_180,
                          _createVNode("div", _hoisted_181, [
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.state.form.firstName = $event)),
                              type: "text",
                              class: "form-control",
                              id: "firstName"
                            }, null, 512), [
                              [_vModelText, _ctx.state.form.firstName]
                            ]),
                            (_ctx.state.errors.firstName)
                              ? (_openBlock(), _createBlock("p", _hoisted_182, _toDisplayString(_ctx.state.errors.firstName), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("div", _hoisted_183, [
                          _hoisted_184,
                          _createVNode("div", _hoisted_185, [
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.state.form.lastName = $event)),
                              type: "text",
                              class: "form-control",
                              id: "lastName"
                            }, null, 512), [
                              [_vModelText, _ctx.state.form.lastName]
                            ]),
                            (_ctx.state.errors.lastName)
                              ? (_openBlock(), _createBlock("p", _hoisted_186, _toDisplayString(_ctx.state.errors.lastName), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("div", _hoisted_187, [
                          _hoisted_188,
                          _createVNode("div", _hoisted_189, [
                            _createVNode(_component_AppEmailAndPhoneNumberValidate, {
                              clear: _ctx.clearInputValue,
                              onUpdateInput: _cache[52] || (_cache[52] = val => _ctx.state.form.contact = val)
                            }, null, 8, ["clear"]),
                            (_ctx.state.errors.contact)
                              ? (_openBlock(), _createBlock("p", _hoisted_190, _toDisplayString(_ctx.state.errors.contact), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _hoisted_191
                      ], 32)
                    ])
                  ]),
                  (_ctx.state.data.formAddedMembers.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_192, [
                        _createVNode("div", _hoisted_193, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.formAddedMembers, (customer) => {
                            return (_openBlock(), _createBlock("div", {
                              key: customer.user_id,
                              class: "d-flex align-items-center mb-2"
                            }, [
                              _createVNode("div", _hoisted_194, [
                                _createVNode("input", {
                                  type: "checkbox",
                                  checked: _ctx.state.data.selectedMemberIds.includes(customer.user_id),
                                  onChange: ($event: any) => (_ctx.toggleMemberSelection(customer.user_id, $event)),
                                  class: "mr-2"
                                }, null, 40, ["checked", "onChange"]),
                                _createVNode("label", _hoisted_195, _toDisplayString(customer.user_first_name) + " " + _toDisplayString(customer.user_last_name) + " (" + _toDisplayString(customer.user_email || customer.user_mobile_number) + ")", 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 512), [
                [_vShow, _ctx.state.activeTab === 'customerstb']
              ])
            ])
          ])
        ]),
        (_ctx.selectedMembers.length)
          ? (_openBlock(), _createBlock("div", _hoisted_196, [
              _hoisted_197,
              _createVNode("div", _hoisted_198, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedMembers, (member, memberIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col-md-4 col-sm-6 mb-2 px-2",
                    key: memberIndex
                  }, [
                    _createVNode("div", _hoisted_199, [
                      _createVNode("p", null, [
                        _hoisted_200,
                        (member.user_first_name || member.user_last_name)
                          ? (_openBlock(), _createBlock("span", _hoisted_201, _toDisplayString(member.user_first_name) + " " + _toDisplayString(member.user_last_name), 1))
                          : (member.user_email)
                            ? (_openBlock(), _createBlock("span", _hoisted_202, _toDisplayString(member.user_email), 1))
                            : (member.user_mobile_number)
                              ? (_openBlock(), _createBlock("span", _hoisted_203, _toDisplayString(member.user_mobile_number), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_204, " Unknown User "))
                      ]),
                      _createVNode("div", _hoisted_205, [
                        (_ctx.isEmail(member.user_email))
                          ? (_openBlock(), _createBlock("div", _hoisted_206, [
                              _createVNode("p", null, [
                                _hoisted_207,
                                _createTextVNode(" " + _toDisplayString(member.user_email), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (member.user_mobile_number)
                          ? (_openBlock(), _createBlock("div", _hoisted_208, [
                              _createVNode("p", null, [
                                _hoisted_209,
                                _createTextVNode(" " + _toDisplayString(member.user_mobile_number), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_210, [
                        _createVNode("div", _hoisted_211, [
                          _hoisted_212,
                          (member.mailNotification)
                            ? (_openBlock(), _createBlock("p", _hoisted_213, [
                                _hoisted_214,
                                _hoisted_215
                              ]))
                            : _createCommentVNode("", true),
                          (member.smsNotification)
                            ? (_openBlock(), _createBlock("p", _hoisted_216, [
                                _hoisted_217,
                                _hoisted_218
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_219, [
                          _createVNode("button", {
                            class: "btn default-btn btn-sm mr-2",
                            title: "Edit",
                            onClick: ($event: any) => (_ctx.editSelectCustomer(member))
                          }, [
                            _hoisted_220,
                            _hoisted_221
                          ], 8, ["onClick"]),
                          _createVNode("a", {
                            class: "btn btn-sm red-btn",
                            title: "Delete",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.removeSelectedMember(member.user_id))
                          }, [
                            _hoisted_222,
                            _hoisted_223
                          ], 8, ["onClick"])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_224, [
          _createVNode("div", _hoisted_225, [
            _createVNode("div", _hoisted_226, [
              _createVNode("div", _hoisted_227, [
                _createVNode("button", {
                  class: "btn default-btn mr-1",
                  onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
                }, [
                  _hoisted_228,
                  _createTextVNode(" " + _toDisplayString(_ctx.state.selectedChannel && (_ctx.state.selectedChannel.name || _ctx.state.selectedChannel.id) ?
                                    "Change Channel" : "Choose Channel to Discuss"), 1)
                ]),
                (_ctx.state.selectedChannel)
                  ? (_openBlock(), _createBlock("span", _hoisted_229, _toDisplayString(_ctx.state.selectedChannel.name), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_230, [
          _createVNode("div", _hoisted_231, [
            _createVNode("div", _hoisted_232, [
              _withDirectives(_createVNode("input", {
                class: "form-check-input mt-0 ml-0",
                type: "checkbox",
                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.state.approveByAll = $event)),
                id: "defaultCheck6"
              }, null, 512), [
                [_vModelCheckbox, _ctx.state.approveByAll]
              ]),
              _createVNode("label", _hoisted_233, _toDisplayString(_ctx.$t('approve_by_all_members')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_234, [
            _createVNode("a", _hoisted_235, [
              _hoisted_236,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('preview')), 1)
            ])
          ])
        ]),
        (_ctx.state.ui.errors.errorList.sendJobEstimation && _ctx.state.ui.errors.errorList.sendJobEstimation.length && _ctx.state.ui.errors.hasError)
          ? (_openBlock(), _createBlock("div", _hoisted_237, [
              _createVNode("div", _hoisted_238, [
                _createVNode("p", null, _toDisplayString(_ctx.$t('errors_scroll_up')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_239, [
          _createVNode("button", {
            type: "submit",
            class: "btn default-btn mr-2",
            onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.sendJobEstimation && _ctx.sendJobEstimation(...args))),
            disabled: _ctx.state.ui.isPostLoading.sendJobEstimation
          }, _toDisplayString(_ctx.state.ui.isPostLoading.sendJobEstimation ?
                        _ctx.$t('loading1') : _ctx.$t('send')), 9, ["disabled"]),
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn outline d-inline-block",
            onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.gotoListJobEstimation && _ctx.gotoListJobEstimation(...args)))
          }, [
            _hoisted_240,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_241, [
        (_ctx.state.ui.showEditCustomerModal)
          ? (_openBlock(), _createBlock("div", _hoisted_242, [
              _createVNode("div", _hoisted_243, [
                _createVNode("div", _hoisted_244, [
                  _createVNode("div", _hoisted_245, [
                    _hoisted_246,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                      onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.closeEditCustomerModal && _ctx.closeEditCustomerModal(...args)))
                    }, [
                      _hoisted_247
                    ])
                  ]),
                  (_ctx.state.data.customerToEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_248, [
                        _createVNode("div", _hoisted_249, [
                          _createVNode("div", _hoisted_250, [
                            _createVNode("div", _hoisted_251, [
                              _createVNode("label", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.state.data.customerToEdit.user_email = $event)),
                                disabled: _ctx.state.data.customerToEdit.isEmailDisabled
                              }, null, 8, ["disabled"]), [
                                [_vModelText, _ctx.state.data.customerToEdit.user_email]
                              ]),
                              _createVNode("p", _hoisted_252, _toDisplayString(_ctx.state.data.customerToEdit.mailNotificationError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_253, [
                            _createVNode("div", _hoisted_254, [
                              _createVNode("label", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('first_name')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.state.data.customerToEdit.user_first_name = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.data.customerToEdit.user_first_name]
                              ]),
                              _createVNode("p", _hoisted_255, _toDisplayString(_ctx.state.data.customerToEdit.firstNameNotificationError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_256, [
                            _createVNode("div", _hoisted_257, [
                              _createVNode("label", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('last_name')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_ctx.state.data.customerToEdit.user_last_name = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.data.customerToEdit.user_last_name]
                              ]),
                              _createVNode("p", _hoisted_258, _toDisplayString(_ctx.state.data.customerToEdit.lastNameNotificationError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_259, [
                            _createVNode("div", _hoisted_260, [
                              _createVNode("label", _hoisted_261, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                              ]),
                              _createVNode(_component_AppPhoneNumberInput, {
                                modelValue: _ctx.state.data.customerToEdit.user_mobile_number,
                                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.state.data.customerToEdit.user_mobile_number = $event)),
                                disabled: _ctx.state.data.customerToEdit.isPhoneDisabled
                              }, null, 8, ["modelValue", "disabled"]),
                              _createVNode("p", _hoisted_262, _toDisplayString(_ctx.state.data.customerToEdit.smsNotificationError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_263, [
                            _createVNode("div", _hoisted_264, [
                              _createVNode("label", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                              ]),
                              _createVNode("div", _hoisted_265, [
                                _createVNode("div", _hoisted_266, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "true",
                                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.state.data.customerToEdit.mailNotification = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.state.data.customerToEdit.mailNotification]
                                  ]),
                                  _createVNode("label", _hoisted_267, _toDisplayString(_ctx.$t('email')), 1)
                                ]),
                                _createVNode("div", _hoisted_268, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "true",
                                    "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.state.data.customerToEdit.smsNotification = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.state.data.customerToEdit.smsNotification]
                                  ]),
                                  _createVNode("label", _hoisted_269, _toDisplayString(_ctx.$t('sms')), 1)
                                ])
                              ]),
                              _createVNode("p", _hoisted_270, _toDisplayString(_ctx.state.data.customerToEdit.mailNotificationError), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_271, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.updateSelectCustomer(_ctx.customerIndex))),
                      disabled: !_ctx.state.data.customerToEdit.mailNotification && !_ctx.state.data.customerToEdit.smsNotification
                    }, " Update ", 8, ["disabled"]),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      "data-dismiss": "modal",
                      onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.closeEditCustomerModal && _ctx.closeEditCustomerModal(...args)))
                    }, " Cancel ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_272, [
        _createVNode("div", _hoisted_273, [
          _createVNode("div", _hoisted_274, [
            _createVNode("div", _hoisted_275, [
              _createVNode("div", _hoisted_276, [
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_ctx.closePreviewModal && _ctx.closePreviewModal(...args)))
                }, [
                  _hoisted_277
                ])
              ]),
              _createVNode("div", _hoisted_278, [
                _createVNode("div", _hoisted_279, [
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_280, [
                        _createVNode("div", _hoisted_281, [
                          _createVNode("div", _hoisted_282, [
                            _createVNode("img", {
                              src: _ctx.state.data.companyInfo.logo.file
                                                ? _ctx.state.data.companyInfo.logo.file
                                                : _ctx.state.data.companyInfo.logo
                                                ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("div", _hoisted_283, [
                            _createVNode("p", null, [
                              _createVNode("strong", _hoisted_284, _toDisplayString(_ctx.$t('address')), 1)
                            ]),
                            _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_285, [
                          _createVNode("p", null, [
                            _createVNode("span", _hoisted_286, _toDisplayString(_ctx.$t('email')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_email), 1)
                          ]),
                          _createVNode("p", null, [
                            _createVNode("span", _hoisted_287, _toDisplayString(_ctx.$t('contact_no')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_phone_number), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("hr", _hoisted_288))
                    : _createCommentVNode("", true),
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_289, [
                        _createVNode("div", _hoisted_290, [
                          _createVNode("p", null, [
                            _createVNode("strong", _hoisted_291, _toDisplayString(_ctx.$t('estimation_title')), 1)
                          ]),
                          _createVNode("p", null, _toDisplayString(_ctx.state.sendData.title), 1)
                        ]),
                        _createVNode("div", _hoisted_292, [
                          _createVNode("p", null, [
                            _createVNode("strong", _hoisted_293, _toDisplayString(_ctx.$t('estimation_no')), 1)
                          ]),
                          _createVNode("p", null, "# " + _toDisplayString(_ctx.state.sendData.no), 1)
                        ]),
                        _createVNode("div", _hoisted_294, [
                          _createVNode("p", null, [
                            _createVNode("strong", _hoisted_295, _toDisplayString(_ctx.$t('date')), 1)
                          ]),
                          _createVNode("p", null, _toDisplayString(_ctx.state.selectedDate), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_296, [
                        (_ctx.selectedMembers && _ctx.selectedMembers.length )
                          ? (_openBlock(), _createBlock("p", _hoisted_297, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_298, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedMembers, (customer, customerIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "col-md-4",
                              key: customerIndex
                            }, [
                              _createVNode("div", _hoisted_299, [
                                (customer.user_first_name || customer.user_last_name)
                                  ? (_openBlock(), _createBlock("p", _hoisted_300, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                                      _createTextVNode(_toDisplayString(customer.user_first_name) + " " + _toDisplayString(customer.user_last_name), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (customer.user_email)
                                  ? (_openBlock(), _createBlock("p", _hoisted_301, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(customer.user_email), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (customer.user_mobile_number)
                                  ? (_openBlock(), _createBlock("p", _hoisted_302, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(customer.user_mobile_number), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_303, [
                    _createVNode("table", _hoisted_304, [
                      _createVNode("thead", _hoisted_305, [
                        _createVNode("tr", _hoisted_306, [
                          _createVNode("th", _hoisted_307, _toDisplayString(_ctx.$t('item')), 1),
                          (_ctx.state.fields.description)
                            ? (_openBlock(), _createBlock("th", _hoisted_308, _toDisplayString(_ctx.$t('description')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.quantity)
                            ? (_openBlock(), _createBlock("th", _hoisted_309, _toDisplayString(_ctx.$t('qty')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.unit)
                            ? (_openBlock(), _createBlock("th", _hoisted_310, _toDisplayString(_ctx.$t('unit')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.cost)
                            ? (_openBlock(), _createBlock("th", _hoisted_311, _toDisplayString(_ctx.$t('cost')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.subTotal)
                            ? (_openBlock(), _createBlock("th", _hoisted_312, _toDisplayString(_ctx.$t('sub_total')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.markup)
                            ? (_openBlock(), _createBlock("th", _hoisted_313, _toDisplayString(_ctx.$t('markup')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.allowance)
                            ? (_openBlock(), _createBlock("th", _hoisted_314, _toDisplayString(_ctx.$t('allowance')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.total)
                            ? (_openBlock(), _createBlock("th", _hoisted_315, _toDisplayString(_ctx.$t('total')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                            _createVNode("td", null, [
                              (item.item.parent_id)
                                ? (_openBlock(), _createBlock("p", _hoisted_316, _toDisplayString(item.main_item_name) + ": " + _toDisplayString(item.name), 1))
                                : (_openBlock(), _createBlock("p", _hoisted_317, _toDisplayString(item.name), 1))
                            ]),
                            (_ctx.state.fields.description)
                              ? (_openBlock(), _createBlock("td", _hoisted_318, [
                                  _createVNode("div", _hoisted_319, [
                                    _createVNode("p", null, _toDisplayString(item.description), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.quantity)
                              ? (_openBlock(), _createBlock("td", _hoisted_320, [
                                  _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.unit)
                              ? (_openBlock(), _createBlock("td", _hoisted_321, [
                                  _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.cost)
                              ? (_openBlock(), _createBlock("td", _hoisted_322, [
                                  _createVNode("p", null, _toDisplayString(item.cost), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.subTotal)
                              ? (_openBlock(), _createBlock("td", _hoisted_323, [
                                  _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.markup)
                              ? (_openBlock(), _createBlock("td", _hoisted_324, [
                                  (item.markup_type == 1)
                                    ? (_openBlock(), _createBlock("p", _hoisted_325, _toDisplayString(item.markup) + " %", 1))
                                    : (_openBlock(), _createBlock("p", _hoisted_326, _toDisplayString(item.markup), 1))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.allowance)
                              ? (_openBlock(), _createBlock("td", _hoisted_327, [
                                  _createVNode("p", null, _toDisplayString(item.allowance), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.total)
                              ? (_openBlock(), _createBlock("td", _hoisted_328, [
                                  _createVNode("p", null, _toDisplayString(item.total), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _hoisted_329,
                  _createVNode("div", _hoisted_330, [
                    _createVNode("div", _hoisted_331, [
                      _createVNode("div", _hoisted_332, [
                        _createVNode("table", _hoisted_333, [
                          _createVNode("tbody", null, [
                            _createVNode("tr", _hoisted_334, [
                              _createVNode("th", _hoisted_335, _toDisplayString(_ctx.$t('total_amount')), 1),
                              _createVNode("th", _hoisted_336, _toDisplayString(_ctx.totalCost), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("hr", _hoisted_337))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement && !_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("p", _hoisted_338, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement && !_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_339, [
                        _createVNode("ul", _hoisted_340, [
                          _createVNode("li", _hoisted_341, [
                            _createVNode("button", _hoisted_342, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                          ]),
                          _createVNode("li", _hoisted_343, [
                            _createVNode("button", _hoisted_344, _toDisplayString(_ctx.$t('legal_statement1')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_345, [
                          _createVNode("div", _hoisted_346, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.companyInfo.acknowledgement
                            }, null, 8, ["innerHTML"])
                          ]),
                          _createVNode("div", _hoisted_347, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.companyInfo.legal_statement
                            }, null, 8, ["innerHTML"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.note && !_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_348, [
                        _createVNode("p", _hoisted_349, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.selectedChannel && _ctx.state.selectedChannel.name && !_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_350, [
                        _createVNode("p", _hoisted_351, [
                          _hoisted_352,
                          _createTextVNode(" " + _toDisplayString(_ctx.state.selectedChannel.name), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.state.data.uploadSignature || _ctx.state.data.cropSignature) && !_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_353, [
                        _createVNode("div", _hoisted_354, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('signature')) + ":", 1)
                          ]),
                          _createVNode("div", _hoisted_355, [
                            _createVNode("img", {
                              src: _ctx.state.data.uploadSignature ? _ctx.state.data.uploadSignature : _ctx.state.data.cropSignature,
                              alt: ""
                            }, null, 8, ["src"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_356, [
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.closePreviewModal && _ctx.closePreviewModal(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_357, [
        _createVNode("div", _hoisted_358, [
          _createVNode("div", _hoisted_359, [
            _createVNode("div", _hoisted_360, [
              _createVNode("div", _hoisted_361, [
                _createVNode("h5", _hoisted_362, _toDisplayString(_ctx.$t('add_company_information')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, [
                  _hoisted_363
                ])
              ]),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createCompanyIfno,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_364, [
                _createVNode("div", _hoisted_365, [
                  _createVNode("div", _hoisted_366, [
                    (!_ctx.state.ui.isLoading.isCompanyEdit)
                      ? (_openBlock(), _createBlock("div", _hoisted_367, [
                          _createVNode("label", _hoisted_368, _toDisplayString(_ctx.$t('company_name')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => (_ctx.state.data.companyInfo.company_name = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_name]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_369, [
                        _createVNode("div", _hoisted_370, [
                          _createVNode("label", _hoisted_371, _toDisplayString(_ctx.$t('phone_number')), 1),
                          _createVNode(_component_AppPhoneNumberInput, {
                            modelValue: _ctx.state.data.companyInfo.company_phone_number,
                            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (_ctx.state.data.companyInfo.company_phone_number = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_372, [
                        _createVNode("div", _hoisted_373, [
                          _createVNode("label", _hoisted_374, _toDisplayString(_ctx.$t('email_address')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => (_ctx.state.data.companyInfo.company_email = $event)),
                            onKeyup: _cache[73] || (_cache[73] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args)))
                          }, null, 544), [
                            [_vModelText, _ctx.state.data.companyInfo.company_email]
                          ]),
                          _createVNode("p", _hoisted_375, _toDisplayString(_ctx.state.ui.errors.companyEroor), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_376, [
                  _createVNode("label", _hoisted_377, _toDisplayString(_ctx.$t('company_logo')), 1),
                  (_ctx.state.data.companyInfo.logo)
                    ? (_openBlock(), _createBlock("div", _hoisted_378, [
                        _createVNode("img", {
                          src: _ctx.state.data.companyInfo.logo.file
                                        ? _ctx.state.data.companyInfo.logo.file
                                        : _ctx.state.data.companyInfo.logo
                                        ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_379, [
                    _createVNode("div", _hoisted_380, [
                      _createVNode("button", _hoisted_381, [
                        _hoisted_382,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                      ]),
                      _createVNode("input", {
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[74] || (_cache[74] = ($event: any) => (_ctx.uploadLogo($event)))
                      }, null, 32)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_383, [
                  _createVNode("label", _hoisted_384, _toDisplayString(_ctx.$t('add_acknowledgement')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.state.data.companyInfo.acknowledgement,
                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_ctx.state.data.companyInfo.acknowledgement = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_385, [
                  _createVNode("label", _hoisted_386, _toDisplayString(_ctx.$t('add_conduct_of_contract')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.state.data.companyInfo.legal_statement,
                    "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => (_ctx.state.data.companyInfo.legal_statement = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_387, [
                (_ctx.state.ui.isLoading.isCompanyEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[77] || (_cache[77] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                    }, _toDisplayString(_ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[78] || (_cache[78] = 
//@ts-ignore
(...args) => (_ctx.createCompanyIfno && _ctx.createCompanyIfno(...args)))
                    }, _toDisplayString(_ctx.$t('save_changes')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[79] || (_cache[79] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_388, [
        _createVNode("div", _hoisted_389, [
          _createVNode("div", _hoisted_390, [
            _createVNode("div", _hoisted_391, [
              _createVNode("div", _hoisted_392, [
                _createVNode("h5", _hoisted_393, _toDisplayString(_ctx.$t('remove_customer')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[80] || (_cache[80] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_394
                ])
              ]),
              _createVNode("div", _hoisted_395, [
                _createVNode("div", _hoisted_396, _toDisplayString(_ctx.$t('are_you_sure_remove_customer')) + ". ", 1)
              ]),
              _createVNode("div", _hoisted_397, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[81] || (_cache[81] = 
//@ts-ignore
(...args) => (_ctx.removeCustomer && _ctx.removeCustomer(...args)))
                }, _toDisplayString(_ctx.state.ui.isLoading.isRemoveCustomer ? _ctx.$t('loading1') : _ctx.$t('remove')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[82] || (_cache[82] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ]),
      _withDirectives(_createVNode(_component_ToDoChatChannelModel, {
        showPhaseChannel: _ctx.state.data.showChatChannelModal,
        selectedChannel: _ctx.state.selectedChannel,
        onClose: _ctx.hideChatChannel,
        onChannelSelected: _ctx.handleChannelSelection
      }, null, 8, ["showPhaseChannel", "selectedChannel", "onClose", "onChannelSelected"]), [
        [_vShow, _ctx.state.data.showChatChannelModal]
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 2,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal,
            titleMessage: _ctx.state.data.successFulMessage
          }, null, 8, ["onClose", "showModal", "titleMessage"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 0,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 1,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
}